import type { Handler } from './handler';
import type {
  ApiFetchGiratudoPrizesPort,
  RafflePrizesResponse,
} from './ports/api-fetch-giratudo-prizes.port';
import { tryCatch } from '~/utils/apostatudo/try-catch';
import { resolveAdapter } from '~/adapters/registry';

export const fetchGiratudoPrizesHandler: Handler<
  Params,
  Ports,
  Result
> = async (
  params,
  ports = {
    apiFetchGiratudoPrizes: resolveAdapter('apiFetchGiratudoPrizes'),
  },
) => {
  const [prizes, error] = await tryCatch(
    ports.apiFetchGiratudoPrizes.handle(
      params.userId,
      params.page,
      params.perPage,
    ),
  );

  if (error) {
    console.error('Error fetching giratudo prizes:', error);

    return {
      data: [],
      currentPage: 1,
      totalPages: 0,
    };
  }

  return prizes as RafflePrizesResponse;
};

type Params = { userId: number; page?: number; perPage?: number };

type Ports = { apiFetchGiratudoPrizes: ApiFetchGiratudoPrizesPort };

type Result = Promise<RafflePrizesResponse>;
